import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {EditableFormField} from 'shells/form/editable-form-field';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {FormSchemaProperty} from '../../../../../core/nutshell-fields/types';
import type {ElementType} from '../../../../types';

import {EnumOptions} from './enum-options';

import styles from './field-styles.module.css';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    fieldSchema: FormSchemaProperty | null | undefined;
    isActive: boolean;
    activeElement: ElementType | null | undefined;
};

export function RadioField(props: Props) {
    const [shouldFocusOnMount, setShouldFocusOnMount] = React.useState<boolean>(
        Boolean(props.isActive && props.activeElement && props.activeElement === 'label')
    );

    const defaultValues = props.watch(`${props.name}.defaultValues`);
    const isRequired = props.watch(`${props.name}.isRequired`);
    const color = props.watch('inputStyle.color');
    const fontSize = props.watch('inputStyle.fontSize');

    return (
        <div style={{fontSize: `${fontSize}px`}}>
            <Controller
                name={`${props.name}.label`}
                control={props.control}
                rules={{
                    maxLength: {
                        value: 255,
                        message: 'Field names can’t exceed 255 characters',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <EditableFormField
                            innerId={field.id}
                            label={field.value}
                            smallBottomMargin={true}
                            errorMessage={errorMessage}
                            editableLabelProps={{
                                onSaveNewValue: (newName) => {
                                    field.onChange(newName);

                                    return new Promise((resolve) => {
                                        // @ts-expect-error
                                        resolve();
                                    });
                                },
                                placeholder: 'Add a title',
                                allowSavingEmpty: false,
                                shouldAllowUndo: false,
                                required: isRequired,
                                tooltip: null,
                                // @ts-expect-error
                                customStyle: {color},
                                isWhite: true,
                                shouldFocusOnMount,
                                onFocusedOnMount: () => setShouldFocusOnMount(false),
                            }}
                        >
                            <Controller
                                name={`${props.name}.placeholder`}
                                control={props.control}
                                render={() => (
                                    <>
                                        {props.fieldSchema ? (
                                            <div
                                                style={{color}}
                                                className={styles['options-container']}
                                            >
                                                <StackLegacy spacing={8}>
                                                    {props.fieldSchema ? (
                                                        <EnumOptions
                                                            fieldSchema={props.fieldSchema}
                                                            // @ts-expect-error
                                                            watch={props.watch}
                                                            displayType='radio'
                                                            style={{
                                                                color,
                                                                fontSize: `${fontSize}px`,
                                                            }}
                                                            defaultValues={defaultValues}
                                                        />
                                                    ) : null}
                                                </StackLegacy>
                                            </div>
                                        ) : undefined}
                                    </>
                                )}
                            />
                        </EditableFormField>
                    );
                }}
            />
        </div>
    );
}
